import { FC } from "react";
import { ReactComponent as FlowersIcon } from "./GiftsNote.svg";
import style from "../ImportantInformation.module.scss";

export const GiftsNote: FC = () => {
  return (
    <li
      data-animation-direction="from-bottom"
      data-animation-delay="300"
    >
      <div className="neela-style">
        <span className="h-lines"></span>
        <span className="v-lines"></span>
        <div className={style.cardTitle}>
          <span className={style.cardIcon}>
            <FlowersIcon style={{ width: 60 }} />
          </span>
          <h3>Gifts note</h3>
        </div>

        <div className="info">
          <p className={style.cardText}>
            Having you celebrate with us is the best gift we could ask for! But
            if you'd still like to give us a little something, we’d love a
            contribution to help kickstart our future adventures together.
          </p>
        </div>
      </div>
    </li>
  );
};
